var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlumpPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27845_171688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 0.75C14.4919 0.75 16.4829 0.813 18.0169 0.895L14.0009 6.25H7.57486L11.6999 0.75H11.9999ZM4.06786 1.022C5.35986 0.917 7.25086 0.808 9.81186 0.767L5.69986 6.25H0.880859C0.923859 5.39 0.973359 4.665 1.02186 4.068C1.15536 2.424 2.42386 1.1555 4.06786 1.022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 12C0.75 10.374 0.777 8.9615 0.818 7.75H23.182C23.223 8.9615 23.25 10.374 23.25 12C23.25 15.7005 23.111 18.2965 22.978 19.932C22.8445 21.576 21.576 22.8445 19.932 22.978C18.2965 23.111 15.7005 23.25 12 23.25C8.2995 23.25 5.7035 23.111 4.068 22.978C2.424 22.8445 1.1555 21.576 1.022 19.932C0.889 18.2965 0.75 15.7005 0.75 12ZM10.379 11.395C9.564 11.08 8.801 11.572 8.6765 12.437C8.5567 13.286 8.49771 14.1426 8.5 15C8.5 16.039 8.5815 16.905 8.6765 17.563C8.8015 18.428 9.564 18.92 10.379 18.605C10.951 18.3835 11.722 18.0385 12.7355 17.5C13.704 16.985 14.4515 16.5295 15.0155 16.1525C15.8945 15.565 15.8945 14.435 15.0155 13.8475C14.4515 13.4705 13.704 13.015 12.7355 12.5C11.722 11.9615 10.951 11.6165 10.379 11.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.12 6.24972C23.077 5.38972 23.0275 4.66472 22.979 4.06772C22.8455 2.42372 21.577 1.15522 19.933 1.02172L19.8055 1.01172L15.877 6.24972H23.12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27845_171688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumpPlay);
export default __webpack_public_path__ + "static/media/plumpPlay.15c268285ef001c76b73298a5d39c302.svg";
export { ForwardRef as ReactComponent };